// extracted by mini-css-extract-plugin
export default {"hub-list-item":"BuyerHub_hub-list-item__rpkqk","hub-list-item__meta":"BuyerHub_hub-list-item__meta__iv-Hl"};